export const pickArrayOfArrayValueByIndex = <T>(
  arr: any[],
  idxs: number[],
): T =>
  arr.reduce(
    (acc, item) => [...acc, pickArrayValuesByIndex<any>(item, idxs)],
    [],
  );

export const pickArrayValuesByIndex = <T>(arr: T[], idxs: number[]): T[] =>
  idxs.map((idx) => arr[idx]);
